<template>
  <div>
    <v-select
      label="Are you a person living with a disability that is recognised as substantially limiting?"
      :items="[{value: true, text: 'Yes'}, {value: false, text: 'No'}]"
      v-model="profile.disabled" @change="submit"
      :color="themes.candidate.light.input"
    />
    <v-select
      v-if="profile.disabled"
      label="Please specify the broad category of your impairment"
      :items="disabilityCategories"
      v-model="profile.disabilityCategory" @change="submit"
      :color="themes.candidate.light.input"
    />
  </div>
</template>

<script>
// Data
import disabilityCategories from '@/data/disability_categories'

// Vue Component
export default {
  props: ['value'],
  data() {
    return {
      // Data
      disabilityCategories,
      // Model (object sent to API)
      profile: {
        disabled: this.value.disabled,
        disabilityCategory: this.value.disabilityCategory,
      }
    }
  },
  methods: {
    submit() {
      this.$store.dispatch('candidate/profile/update', this.profile)
    }
  }
}
</script>
